<app-edit-component-base (onCancel)="cancel()"
                         (onNextView)="setCurrent(current * 2)"
                         (onPreviousView)="setCurrent(current / 2)"
                         (onSave)="save()"
                         [id]="persistence.Id"
                         [templates]="{'1': GeneralInformation, '2': LegalInformation, '4': TaxInformation}"
                         [title]="'Shard ' + (editing ? 'bearbeiten' : 'anlegen')" [view]="current">
  <ng-container steps>
    @for (step of StepsList; track step) {
      <li editComponentStep [model]="step" [current]="current" [index]="$index" [label]="StepsLabels[step]"
          (currentChange)="setCurrent($event)">

      </li>
    }
  </ng-container>

  <ng-template #GeneralInformation>
    @if (persistence.entity) {
      <configuration-segment description="" title="Allgemeine Informationen">
        <configuration-input-field [(value)]="persistence.entity.name" [required]="true"
                                   autocomplete="shard-naem" class="col-span-full"
                                   id="shard-name" label="Shard Name"
                                   name="shard-name" placeholder="Musterclub">
          <span class="select-all">{{ persistence.entity.id ?? "Neu" }}</span>
          /
        </configuration-input-field>
      </configuration-segment>
      <configuration-segment description="" title="Adresse">
        <configuration-input-field [(value)]="persistence.entity.address.street"
                                   [required]="true" autocomplete="address-street" class="col-span-full"
                                   id="address-street" label="Straße" name="address-street"
                                   placeholder="Musterstr.">
        </configuration-input-field>
        <configuration-input-field [(value)]="persistence.entity.address.houseNumber"
                                   autocomplete="address-house-number" class="col-span-4"
                                   id="address-house-number" label="Hausnummer"
                                   name="address-house-number" placeholder="123"
                                   validationPattern="^[0-9]+$">
        </configuration-input-field>
        <configuration-input-field
          (valueChange)="persistence.entity.address.houseNumberSuffix = $event.isNullOrWhitespace() ? undefined : $event"
          [value]="persistence.entity.address.houseNumberSuffix ?? ''"
          autocomplete="address-house-number-suffix" class="col-span-2"
          id="address-house-number-suffix" label="Hausnummernzusatz"
          name="address-house-number-suffix" placeholder="a" validationPattern=".{0,20}">
        </configuration-input-field>

        <configuration-input-field
          (valueChange)="persistence.entity.address.additionalAddressLine = $event.isNullOrWhitespace() ? undefined : $event"
          [value]="persistence.entity.address.additionalAddressLine ?? ''" autocomplete="address-additional"
          class="col-span-full" id="address-additional"
          label="Adresszusatz"
          name="address-additional"
          placeholder="z.B. Hinterhaus" validationPattern=".{0,46}">
        </configuration-input-field>

        <configuration-input-field [(value)]="persistence.entity.address.zipCode"
                                   [required]="true" autocomplete="address-zip-code"
                                   class="col-span-full sm:col-span-2" id="address-zip-code"
                                   label="Postleitzahl"
                                   name="address-zip-code" placeholder="12345"
                                   validationPattern="^([0]{1}[1-9]{1}[0-9]{3})|([1-9]{1}[0-9]{4})$">
        </configuration-input-field>

        <configuration-input-field [(value)]="persistence.entity.address.city"
                                   [required]="true" autocomplete="address-city" class="col-span-full sm:col-span-2"
                                   id="address-city"
                                   label="Stadt" name="address-city"
                                   placeholder="Musterstadt">
        </configuration-input-field>

        <div class="sm:col-span-2">
          <label class="block text-sm/6 font-medium text-gray-900" for="country">Land*</label>
          <div class="mt-2 grid grid-cols-1">
            <select autocomplete="country-name"
                    class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline sm:text-sm/6"
                    id="country"
                    name="country">
              <option>Deutschland</option>
            </select>
            <svg aria-hidden="true"
                 class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                 data-slot="icon"
                 viewBox="0 0 16 16">
              <path
                clip-rule="evenodd"
                d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                fill-rule="evenodd"/>
            </svg>
          </div>
        </div>
        <div class="col-span-full">
          <label class="block text-sm/6 font-medium text-gray-900" for="preferred-address">Als bevorzugte Adresse
            verwenden</label>
          <div class="mt-0.5 grid grid-cols-1">
            <div>
              <input [(ngModel)]="persistence.entity.isPreferredAddress"
                     [disabled]="persistence.entity.legalInformation != undefined || persistence.entity.taxInformation != undefined"
                     autocomplete="preferred-address"
                     class="col-start-1 row-start-1 rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline sm:text-sm/6 disabled:opacity-80"
                     id="preferred-address" name="preferred-address" type="checkbox"/>
            </div>
          </div>
        </div>
      </configuration-segment>
      <configuration-segment description="" title="Metadata">
        <configuration-input-field (valueChange)="persistence.entity.setMetadata('Color', $event)"
                                   [value]="persistence.entity.metadata?.Color ?? ''"
                                   class="col-span-full" id="color"
                                   label="Farbe" name="color" placeholder="z. b. #ff0000"
                                   type="color">
        </configuration-input-field>
      </configuration-segment>
    }

  </ng-template>
  <ng-template #LegalInformation>
    @if (persistence.entity) {
      <configuration-segment [useDefaultTitle]="false">
        <ng-container header>
          <div>
            <div class="grid grid-cols-1 sm:hidden pt-4">
              <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
              <select (ngModelChange)="persistence.entity.setLegalType(parseInt($event))"
                      [ngModel]="persistence.entity.legalInformation?.legalType"
                      aria-label="Rechtsart wählen"
                      class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300">
                <option [selected]="persistence.entity.legalInformation == undefined" [value]="undefined">Standard
                </option>
                @for (type of LegalTypeList; track type) {
                  <option [value]="type"
                          [selected]="type == persistence.entity.legalInformation?.legalType">{{ LegalTypeLabels[type] }}
                  </option>
                }
              </select>
              <svg aria-hidden="true"
                   class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
                   data-slot="icon"
                   viewBox="0 0 16 16">
                <path
                  clip-rule="evenodd"
                  d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                  fill-rule="evenodd"/>
              </svg>
            </div>
            <div class="hidden sm:block">
              <div class="border-b border-gray-200">
                <a (click)="persistence.entity.setLegalType(undefined)"
                   [ngClass]="{'!border-theme-primary-700 text-theme-primary-700': undefined == persistence.entity.legalInformation?.legalType}"
                   class="group w-full inline-flex items-center border-b-2 border-transparent px-1 pb-2 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700">
                  <!-- Current: "text-theme-primary-700", Default: "text-gray-400 group-hover:text-gray-500" -->
                  <svg
                    [ngClass]="{'text-theme-primary-700': undefined == persistence.entity.legalInformation?.legalType}"
                    aria-hidden="true" class="-ml-0.5 mr-2 size-5 text-gray-400 group-hover:text-gray-500"
                    data-slot="icon"

                    viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M216 112v96a16 16 0 0 1-16 16H56a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h24a8 8 0 0 1 0 16H56v96h144v-96h-24a8 8 0 0 1 0-16h24a16 16 0 0 1 16 16M93.66 69.66L120 43.31V136a8 8 0 0 0 16 0V43.31l26.34 26.35a8 8 0 0 0 11.32-11.32l-40-40a8 8 0 0 0-11.32 0l-40 40a8 8 0 0 0 11.32 11.32"
                    />
                  </svg>
                  <span>Vom Unternehmen übernehmen</span>
                </a>
                <nav aria-label="Tabs" class="-mb-px flex space-x-8">
                  @for (type of LegalTypeList; track type) {
                    <!-- Current: "border-theme-primary-700 text-theme-primary-700", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" -->
                    <a (click)="persistence.entity.setLegalType(type)"
                       class="group inline-flex items-center border-b-2 border-transparent px-1 pb-2 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
                       [ngClass]="{'!border-theme-primary-700 text-theme-primary-700': type == persistence.entity.legalInformation?.legalType}">
                      <!-- Current: "text-theme-primary-700", Default: "text-gray-400 group-hover:text-gray-500" -->
                      <svg viewBox="0 0 20 20" data-slot="icon" aria-hidden="true"
                           class="-ml-0.5 mr-2 size-5 text-gray-400 group-hover:text-gray-500"
                           [ngClass]="{'text-theme-primary-700': type == persistence.entity.legalInformation?.legalType}">
                        @switch (type) {
                          @case (LegalType.NaturalPerson) {
                            <path
                              d="M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z"/>
                          }
                          @case (LegalType.LegalEntity) {
                            <path
                              d="M4 16.5v-13h-.25a.75.75 0 0 1 0-1.5h12.5a.75.75 0 0 1 0 1.5H16v13h.25a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 0-.75-.75h-2.5a.75.75 0 0 0-.75.75v2.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1 0-1.5H4Zm3-11a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM11 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm.5 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"
                              clip-rule="evenodd" fill-rule="evenodd"/>
                          }
                        }
                      </svg>
                      <span>{{ LegalTypeLabels[type] }}</span>
                    </a>
                  }
                </nav>
              </div>
            </div>
          </div>
        </ng-container>

        @if (persistence.entity.legalInformation) {
          @switch (persistence.entity.legalInformation.legalType) {
            @case (LegalType.LegalEntity) {
              <configuration-input-field class="col-span-full"
                                         id="company-name" name="company-name" autocomplete="company-name"
                                         label="Firmenname" placeholder="Musterfirma"
                                         [(value)]="persistence.entity.legalInformation.asAny().name"
                                         [required]="true">
              </configuration-input-field>
              <div class="sm:col-span-6">
                <!--
                  `for` must name the INNER input ng-select renders, not the `<ng-select>` host: a custom
                  element is not labelable, so `for="legal-form"` left this combobox unlabelled (axe `label`,
                  critical). `labelForId` is ng-select's own hook for that id.
                -->
                <label for="legal-form-input" class="text-sm/6 font-medium text-gray-900 inline-flex gap-x-1">
                  Rechtsform*
                </label>
                <!--
                  #236: this page is built on `app-edit-component-base`, which projects its content INSIDE
                  `layout-page-scrollable` — whose `.page-scroller` is the page's scroll container and used to
                  slice the option list off. `.page-viewport` is `layout-page-container`'s own box: positioned
                  (`absolute inset-0`, so it can be the panel's containing block) and one level ABOVE
                  `.page-scroller`, i.e. outside the clip. `NgSelectScrollAwareDirective` rides along on the
                  `ng-select[appendTo]` selector and keeps the panel glued to the input while that box scrolls.
                -->
                <ng-select id="legal-form" class="mt-2 ng-select cheqme-style text-sm" [clearable]="false"
                           appendTo=".page-viewport" labelForId="legal-form-input"
                           [(ngModel)]="persistence.entity.legalInformation.asAny().legalForm">
                  @for (form of LegalFormList; track form) {
                    <ng-option [value]="form">{{ LegalFormDescription[form] }}</ng-option>
                  }
                </ng-select>
              </div>
            }
            @case (LegalType.NaturalPerson) {
              <div class="col-span-full sm:col-span-2">
                <!-- `for` names the inner input, see the note on "Rechtsform" above. -->
                <label for="salutation-input" class="text-sm/6 font-medium text-gray-900 inline-flex gap-x-1">
                  Anrede*
                </label>
                <!-- #236: portaled out of `.page-scroller`; see the note on "Rechtsform" above. -->
                <ng-select id="salutation" class="mt-2 ng-select cheqme-style text-sm" [clearable]="false"
                           appendTo=".page-viewport" labelForId="salutation-input"
                           [(ngModel)]="persistence.entity.legalInformation.asAny().salutation">
                  @for (salutation of SalutationList; track salutation) {
                    <ng-option [value]="salutation">{{ SalutationLabels[salutation] }}</ng-option>
                  }
                </ng-select>
              </div>
              <configuration-input-field class="col-span-full sm:col-start-1 sm:col-span-3"
                                         id="first-name" name="first-name" autocomplete="given-name"
                                         label="Vorname" placeholder="Max"
                                         [(value)]="persistence.entity.legalInformation.asAny().firstName"
                                         [required]="true">
              </configuration-input-field>

              <configuration-input-field class="col-span-full sm:col-span-3"
                                         id="last-name" name="last-name" autocomplete="family-name"
                                         label="Nachname" placeholder="Mustermann"
                                         [(value)]="persistence.entity.legalInformation.asAny().lastName"
                                         [required]="true">
              </configuration-input-field>

              <configuration-input-field class="col-span-full sm:col-span-2"
                                         id="birth-date" name="birth-date" autocomplete="bday"
                                         label="Geburtsdatum" placeholder="01.01.2000"
                                         [(value)]="persistence.entity.legalInformation.asAny().dateOfBirth"
                                         type="date" [required]="true">
              </configuration-input-field>

              <configuration-input-field class="col-span-full sm:col-span-3 sm:col-start-4"
                                         id="identification-number" name="identification-number"
                                         autocomplete="identification-number"
                                         label="Identifikationsnummer" placeholder="12345678901"
                                         validationPattern="^[0-9]{11}$" [required]="true"
                                         [(value)]="persistence.entity.legalInformation.asAny().identificationNumber">
                <span>XXXXXXXXXX</span>
              </configuration-input-field>
            }
          }
        } @else {
          <span class="col-span-full">Unternehmensdaten werden für diesen Shard übernommen.</span>
        }
      </configuration-segment>
    }
  </ng-template>
  <ng-template #TaxInformation>
    @if (persistence.entity) {
      <configuration-segment [useDefaultTitle]="false">
        <ng-container header>
          <div>
            <div class="grid grid-cols-1 sm:hidden pt-4">
              <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
              <select (ngModelChange)="persistence.entity.setTaxInformation($event)"
                      [ngModel]="persistence.entity.taxInformation"
                      aria-label="Steuerinformationen übernehmen"
                      class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300">
                <option [selected]="persistence.entity.taxInformation == undefined" [value]="true">
                  Vom Unternehmen übernehmen
                </option>
                <option [selected]="persistence.entity.taxInformation != undefined" [value]="false">
                  Steuerinformationen anlegen
                </option>
              </select>
              <svg aria-hidden="true"
                   class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500"
                   data-slot="icon"
                   viewBox="0 0 16 16">
                <path
                  clip-rule="evenodd"
                  d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                  fill-rule="evenodd"/>
              </svg>
            </div>
            <div class="hidden sm:block">
              <div class="border-b border-gray-200">
                <a (click)="persistence.entity.setTaxInformation(true)"
                   [ngClass]="{'!border-theme-primary-700 text-theme-primary-700': undefined == persistence.entity.taxInformation}"
                   class="group w-full inline-flex items-center border-b-2 border-transparent px-1 pb-2 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700">
                  <!-- Current: "text-theme-primary-700", Default: "text-gray-400 group-hover:text-gray-500" -->
                  <svg
                    [ngClass]="{'text-theme-primary-700': undefined == persistence.entity.taxInformation}"
                    aria-hidden="true" class="-ml-0.5 mr-2 size-5 text-gray-400 group-hover:text-gray-500"
                    data-slot="icon"

                    viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M216 112v96a16 16 0 0 1-16 16H56a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h24a8 8 0 0 1 0 16H56v96h144v-96h-24a8 8 0 0 1 0-16h24a16 16 0 0 1 16 16M93.66 69.66L120 43.31V136a8 8 0 0 0 16 0V43.31l26.34 26.35a8 8 0 0 0 11.32-11.32l-40-40a8 8 0 0 0-11.32 0l-40 40a8 8 0 0 0 11.32 11.32"
                    />
                  </svg>
                  <span>Vom Unternehmen übernehmen</span>
                </a>
              </div>
              <div class="border-b border-gray-200">
                <a (click)="persistence.entity.setTaxInformation(false)"
                   [ngClass]="{'!border-theme-primary-700 text-theme-primary-700': undefined != persistence.entity.taxInformation}"
                   class="group w-full inline-flex items-center border-b-2 border-transparent px-1 pb-2 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700">
                  <!-- Current: "text-theme-primary-700", Default: "text-gray-400 group-hover:text-gray-500" -->
                  <svg [ngClass]="{'text-theme-primary-700': undefined != persistence.entity.taxInformation}"
                       aria-hidden="true" class="-ml-0.5 mr-2 size-5 text-gray-400 group-hover:text-gray-500"
                       data-slot="icon"

                       viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M216 112v96a16 16 0 0 1-16 16H56a16 16 0 0 1-16-16v-96a16 16 0 0 1 16-16h24a8 8 0 0 1 0 16H56v96h144v-96h-24a8 8 0 0 1 0-16h24a16 16 0 0 1 16 16M93.66 69.66L120 43.31V136a8 8 0 0 0 16 0V43.31l26.34 26.35a8 8 0 0 0 11.32-11.32l-40-40a8 8 0 0 0-11.32 0l-40 40a8 8 0 0 0 11.32 11.32"
                    />
                  </svg>
                  <span>Steuerinformationen anlegen</span>
                </a>
              </div>
            </div>
          </div>
        </ng-container>
        @if (persistence.entity.taxInformation) {
          <configuration-input-field class="col-span-full" label="Steuernummer" placeholder="Steuernummer"
                                     id="tax-number" name="tax-number" autocomplete="tax-number"
                                     [(value)]="persistence.entity.taxInformation.taxNumber"
                                     validationPattern="^[0-9]{4}0[0-9]{8}$" [required]="true">
            <span>XXXX0XXXXXXXX</span>
          </configuration-input-field>
          <configuration-input-field class="col-span-full" label="USt.-ID" placeholder="DE123456789"
                                     id="vat-number" name="vat-number" autocomplete="tax-number"
                                     [value]="persistence.entity.taxInformation.vatNumber ?? ''"
                                     (valueChange)="persistence.entity.taxInformation.vatNumber = $event.isNullOrWhitespace() ? undefined : $event"
                                     validationPattern="^(DE[0-9]{9}|)$">
            <span>DEXXXXXXXXX</span>
          </configuration-input-field>
        } @else {
          <span class="col-span-full">Steuerinformationen werden für diesen Shard übernommen.</span>
        }
      </configuration-segment>
    }
  </ng-template>
</app-edit-component-base>
